import styles from "./HomePageSearchBox.module.css"
import search from "./../../assets/search_icon.png"
import React from "react"
import ImageWithFallback from '../ImageWithFallback';

export default function HomePageSearchBox() {
    return(
        <div className={styles.vars}>
            <form onSubmit={(e) => e.preventDefault()} role="search" className={styles.form}>
                <label htmlFor="search" className={styles.label}>Search for stuff</label>
                <input id="search" type="search" placeholder="Tìm kiếm cùng bHive" autoFocus required className={styles.input} />
                <button type="submit" className={styles.button}>
                    <ImageWithFallback loading="lazy" src={search} alt="Search icon" />
                </button>
            </form>
        </div>
    );
}